import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  IconButton,
  Typography
} from '@mui/material';

import {
  LeftPanelCloseOutlined
} from '../../../../../Common/components/Icons/icons';

import {
  expandButtonSx,
  headerSx,
  headerTitleSx,
  orderHxLinkSx
} from './MHxSoapStyles';

const MHxSoapHeader = ({
  readOnly,
  showOrderHx,
  onOpenOrderHx,
  onToggleExpand
}) => {
  return (
    <Box sx={headerSx}>
      <Typography sx={headerTitleSx}>
        Medical Hx Summary
      </Typography>

      {!readOnly && showOrderHx && (
        <Typography
          onClick={onOpenOrderHx}
          sx={orderHxLinkSx}>
          Order Hx
        </Typography>
      )}

      {readOnly && onToggleExpand && (
        <IconButton
          size="small"
          onClick={onToggleExpand}
          aria-label="Expand encounter"
          sx={expandButtonSx}>
          <LeftPanelCloseOutlined />
        </IconButton>
      )}
    </Box>
  );
};

MHxSoapHeader.propTypes = {
  readOnly: PropTypes.bool,
  showOrderHx: PropTypes.bool,
  onOpenOrderHx: PropTypes.func,
  onToggleExpand: PropTypes.func
};

export default MHxSoapHeader;